import { closeOnlineAtom, onlineDataAtom, isOnlineOpenAtom } from '../../../stores/online.store' // 假设你有控制显示的 atom
import { useAtom } from 'jotai'
import { useStyle } from '../../../style'
import { CloseOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import { useState, useEffect } from 'react'

const OnlineSidebar = () => {
  const { styles } = useStyle()
  const [width, setWidth] = useState(window.innerWidth)

  // 假设 isOnlineOpenAtom 控制侧边栏/弹窗的打开状态
  const [isOpen, setIsOpen] = useAtom(isOnlineOpenAtom)
  const [, closeOnline] = useAtom(closeOnlineAtom)
  const [onlineData] = useAtom(onlineDataAtom)

  // 监听窗口大小变化
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isMobile = width < 1400

  // 抽离渲染内容，保持 UI 一致
  const renderContent = () => (
    <div className={styles.onlineList}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {onlineData?.map((item, index) => (
          <a
            key={index}
            href={item.url}
            className={styles.onlineItem}
            target="_blank"
            rel="noreferrer"
          >
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={item.icon}
                  alt={item.siteName}
                  style={{ width: 20, height: 20, marginRight: 12, borderRadius: '50%' }}
                />
                <div style={{ fontSize: 12, color: 'rgb(97, 102, 107)' }}>
                  {item.siteName}
                </div>
              </div>
              <div style={{ fontSize: 16, color: 'rgb(15, 17, 21)', marginTop: 6 }}>
                {item.title}
              </div>
              {item.summary && (
                <div className={styles.onlineSummary}>{item.summary}</div>
              )}
            </div>
          </a>
        ))}
      </div>
    </div>
  )

  // 情况 A: 窄屏显示为 Drawer
  if (isMobile) {
    return (
      <Drawer
        title="搜索结果"
        placement="right"
        onClose={() => closeOnline()}
        open={isOpen} // 这里需要根据你的状态管理来控制
        width="90%"
        styles={{ body: { padding: 0 } }} // 移除默认 padding 以匹配原有样式
      >
        {renderContent()}
      </Drawer>
    )
  }

  // 情况 B: 宽屏显示为固定侧边栏
  return (
    <div className={styles.onlineContainer}>
      <div className={styles.onlineHeader}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: 'rgba(0,0,0,.85)' }}>
          搜索结果
        </h3>
        <Button
          onClick={closeOnline}
          icon={<CloseOutlined />}
          style={{ border: 'none' }}
        />
      </div>
      {renderContent()}
    </div>
  )
}

export default OnlineSidebar